module.exports = __webpack_public_path__ + "static/media/logoERecetaW.b48986af.png";